<template>
  <!-- <div id="rec"> -->
    <v-expansion-panel>
      <v-expansion-panel-header>
        {{ Rec.fields.TITLE }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- <v-card v-show="Condition" class="mx-auto my-12"> -->
          <v-container>
            <v-row>
              <v-col>
                <v-img class="recImg" height="150" contain :src="Rec.fields.IMAGE" :alt="Rec.fields.TITLE"></v-img>
              </v-col>
              <v-col>
                <v-card-title class="font-weight-black">{{
              Rec.fields.TITLE
            }}</v-card-title>

                <v-card-text>
                  <v-row align="center" class="mx-0">
                    <v-rating aria-label="Rate out of 5 stars" :value="parseFloat(Rec.fields.RATING)" half-increments
                      readonly>
                      <template v-slot:item="props">
                        <v-icon aria-label="star" color="amber" size="20">{{
                      props.isFilled ? 'mdi-star' : 'mdi-star-outline'
                    }}</v-icon>
                      </template>
                    </v-rating>

                    <div class="black--text ml-4">
                      {{ Rec.fields.RATING }} ({{ Rec.fields.REVIEWS }})
                    </div>
                  </v-row>

                  <div class="my-4 subtitle-1 black--text">
                    {{ Rec.fields.PRICE }}

                    <v-chip class="ml-4">{{ Rec.fields.TYPE }}</v-chip>
                  </div>

                  <div>
                {{ Rec.fields.DESCRIPTION }}
              </div>
                </v-card-text>



                <v-card-actions>
                  <v-row>
                    <v-col>
                      <router-link :to="{ name: 'Details', query: { record: Rec.fields.RECORD_ID } }" @click="this.$ga.event({
  eventCategory: 'recommendations',
  eventAction: 'route-to-details-page',
  eventLabel: 'see-more-details-button'
})">
                        <v-btn class="pl-4 pr-6 mr-6" x-large color="amber darken-1"
                          aria-label="See more details button">
                          <v-icon class="pr-3">
                            mdi-note-text
                          </v-icon>
                          See More Details
                        </v-btn>
                      </router-link>
                    </v-col>
                    <!-- <v-col>
                    <v-btn
                      class="pl-4 pr-6"
                      x-large
                      :disabled="isDisabled"
                      color="amber darken-1"
                      @click="addToCart(Rec)"
                      aria-label="Add to cart button"
                    >
                      <img
                        class="pl-3 pr-3"
                        src="@/assets/icons/add_shopping_cart.svg"
                        alt="Add to shopping cart icon"
                      />
                      Add to your cart</v-btn
                    >
                  </v-col> -->
                    <v-col>
                      <v-btn class="pl-12 pr-12" @click="enroll(Rec.fields.URL)" x-large color="primary"
                        aria-label="Enroll button">
                        <v-icon class="pr-3">mdi-checkbox-marked-circle-outline</v-icon>
                        Enroll
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        <!-- </v-card> -->
      </v-expansion-panel-content>
    </v-expansion-panel>
  <!-- </div> -->
</template>

<script>
  export default {
    name: 'CondensedRec',
    props: {
      Rec: [Object]
    },
    methods: {
    //   addToCart(t) {
    //   this.$store.dispatch('addCartItem', t);

    //   window.aa('AddToCartFromDetails', {
    //     userToken: 'user-1928fh19fh38',
    //     index: 'Airtable',
    //     eventName: 'add_to_cart',
    //     objectIDs: ['objectID1', 'objectID2'],
    //   });

    //   // this.isDisabled = true;
    // },
    enroll(url) {
      window.open(`${url}`,'_blank','noopener');
    },
    },
  }
</script>

<style lang="scss" scoped>
  #rec {
    // awef
    // .recImg {
    //   width: 5rem;
    // }
  }
</style>